import { render, staticRenderFns } from "./orderDetailTextarea.vue?vue&type=template&id=4924d78a&scoped=true"
import script from "./orderDetailTextarea.vue?vue&type=script&lang=js"
export * from "./orderDetailTextarea.vue?vue&type=script&lang=js"
import style0 from "./orderDetailTextarea.vue?vue&type=style&index=0&id=4924d78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924d78a",
  null
  
)

export default component.exports